import React from 'react';
import Header from "../../components/Header/index";
import { Link } from 'react-router-dom';
import AuthApi from "../../services/portal-api/AuthApi";
import { IT_SUPPORT_EMAIL, IT_SUPPORT_PHONE } from "../../helpers/Constants";
import AuthService from "../../services/AuthService";
import LoadingSpinner from "../../components/LoadingSpinner";
import MembersApi from '../../services/portal-api/MembersApi';
import SelectInput from '../../components/Form/components/SelectInput';
import swal from 'sweetalert';

export default class Login extends React.Component {

    constructor(props) {
        super(props);

        let showLoggedOut = false;
        if (typeof props.history.location.state !== 'undefined' && props.history.location.state.showLoggedOut) {
            showLoggedOut = true;
        }

        let showResetSuccessfully = false;
        if (typeof props.history.location.state !== 'undefined' && props.history.location.state.showResetSuccessfully) {
            showResetSuccessfully = true;
        }

        this.state = {
            showLoggedOut: showLoggedOut,
            showResetSuccessfully: showResetSuccessfully,
            username: '',
            password: '',
            isLoading: false,
            errors: {},
            needsReset: false,
            selectStore: false,
            resetQuestions: false,
            stores: [],
            storeId: '',
            userId: '',
            ip: ''
        };
        this.handleChangeStoreSelection = this.handleChangeStoreSelection.bind(this);
    }

    componentDidMount() {
        document.title = 'Login - duskPortal';
        document.body.className = '';

        this.getLocalIP((myIP) => {
            this.setState({ ip: myIP });
        });

        if (AuthService.isLoggedIn()) {
            this.props.history.replace('/');
        }
    }

    componentWillUnmount() {
        // No longer care about any API calls in progress
        this.loginCallId = null;
    }

    getLocalIP(callback) {
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;   
        var pc = new RTCPeerConnection({ iceServers: [] }), noop = function () { };
        pc.createDataChannel("");    
        pc.createOffer(pc.setLocalDescription.bind(pc), noop);   
        pc.onicecandidate = (ice) => {  
            if (!ice || !ice.candidate || !ice.candidate.candidate) return;
            var myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
            console.log("myIP: " + myIP);
            pc.onicecandidate = noop;
            callback(myIP);
        };
    }

    handleSubmit = (event) => {
        // Chrome
        // In the address bar, type and the following text: chrome://flags/#enable-webrtc-hide-local-ips-with-mdns
        // Firefox
        // In the address bar, type "about:config" and press Enter.
        // Proceed if you understand and accept the risks.
        // In the search bar at the top, type "media.peerconnection.ice.obfuscate_host_addresses" and press Enter.
        // You should see a preference named "media.peerconnection.ice.obfuscate_host_addresses" in the list.
        // Double-click the preference to toggle its value. Set it to "false".

        
        // Prevent default behaviour
        event.preventDefault();

        // Show loading and reset state
        this.setState({
            showLoggedOut: false,
            showResetSuccessfully: false,
            isLoading: true,
            errors: {},
        });

        // Fetch data 
        this.loginCallId = AuthApi.login(this.state.username, this.state.password, this.state.ip, (response, callId) => {
            // Check if we're still interesting in this response
            if (callId !== this.loginCallId) {
                return;
            }

            // Check for errors
            if (response.status !== 200) {
                this.setState({
                    isLoading: false,
                    errors: {
                        login: response.json.error,
                    }
                });
                return;
            }

            // Logged in! Store token and redirect
            AuthService.setToken(response.json.access_token);
            AuthService.setLocalStorageStoreId(response.json.auth_user.lastLoggedInStore);
            AuthService.setLocalStorageRoleId(response.json.auth_user.is_admin);
            AuthService.setPermissions(JSON.stringify(response.json.permissions));
            console.log("admintype",AuthService.getAdminType());
            const authUserId = response.json.auth_user.id;
            const customizeSecurityQuestions = response.json.auth_user.customizeSecurityQuestions;
            if (response.json.auth_user.lastLoggedInStore == null && (AuthService.getAdminType() == 0 || AuthService.getAdminType() == 2 || AuthService.getAdminType() == 3)) {
            // if (AuthService.getAdminType() == 0 || AuthService.getAdminType() == 2 || AuthService.getAdminType() == 3) {
                this.setState({
                    selectStore: true,
                    userId: response.json.auth_user.id,
                    resetQuestions: customizeSecurityQuestions == 1 ? true : false
                }, () => {
                    this.fetchstoreDetailsAndStores(response.json.generate_dropdown);
                });
            } else {
                AuthApi.getSecStage((response) => {
                    if (response.json.success) {
                        let stage = response.json.stage;
                        localStorage.setItem('s-stage', stage);
                        if (stage != 'sc') {
                            // this.props.history.replace('/reset/in');
                            this.props.history.replace('/reset/in');
                        } else if(stage == 'sc' && customizeSecurityQuestions == 1) {
                            this.props.history.replace('/security/' + authUserId);
                        } else {
                            this.props.history.replace('/');
                        }
                    }
                });
            }

        });
    };

    fetchstoreDetailsAndStores(stores) {
        MembersApi.fetchstoreDetailsAndStores((result) => {
            if (result.success) {
                if (result.json.storeDetails != null) {
                    sessionStorage.setItem("store-name", result.json.storeDetails.name);
                }

                this.setState({
                    'stores': stores,
                    'storeId': (result.json.storeDetails != null) ? result.json.storeDetails.id : ''
                }, () => {
                    AuthService.setDoNotRefreshStoreSelection(JSON.stringify(this.state.stores));
                    console.log(this.state.stores);
                });
            }
        }, AuthService.getUserId());
    }

    handleChangeStoreSelection = (event) => {
        const value = event.target.value;
        const sendParams = {
            storeId: value,
            userId: AuthService.getUserId()
        };

        MembersApi.setStoreAndRole(sendParams, (response) => {
            if (response.success) {
                AuthService.setLocalStorageStoreId(value);
                AuthService.setLocalStorageRoleId(response.json.isAdmin);
                AuthService.setDoNotRefreshStoreSelection('');
                AuthService.setPermissions(JSON.stringify(response.json.permissions));
                console.log(response.json.permissions);
                AuthApi.getSecStage((response) => {
                    if (response.json.success) {
                        let stage = response.json.stage;
                        localStorage.setItem('s-stage', stage);
                        if (stage != 'sc') {
                            this.props.history.replace('/reset/in');
                        } else if(stage == 'sc' && this.state.resetQuestions == true) {
                            this.props.history.replace('/security/' + AuthService.getUserId());
                        } else {
                            this.props.history.replace('/');
                        }
                    }
                });

            } else {
                response.status === 401 ? swal("Something went wrong", {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                }) : console.log(response);
            }
        });
    };

    handleChange = (event) => {
        const errors = this.state.errors;
        delete errors[event.target.name];
        this.setState({
            [event.target.name]: event.target.value,
            errors: errors
        });
    };

    render() {
        const isSubmitEnabled = (
            !this.state.isFormLoading &&
            this.state.username !== '' &&
            this.state.password !== ''
        );

        // const storesOption = this.state.stores.map(store => {
        //     return (
        //         <option value={store.storeId} key={store.storeId}>{store.storeName}</option>
        //     )
        // })

        let storesOption = [];
        this.state.stores.forEach(store => {
            storesOption.push({key: store.storeId, value: store.storeName});
        });

        return <div>
            <Header isLoggedOut isReset={false} />
            <main className="content" role="main">
                {!this.state.selectStore && <div className="vertab">
                    <div className="vertab--inner viewport bg--grey">

                        <div className="container container--xnarrow padding--100--top padding--100--bot">

                            {this.state.errors.login && <div className="alert alert--outline alert--error text--center margin--25--bot">
                                Unable to log in: {this.state.errors.login}
                            </div>}

                            {this.state.showLoggedOut && <div className="alert alert--outline alert--success text--center margin--25--bot">
                                You are now logged out.
                            </div>}

                            {this.state.showResetSuccessfully && <div className="alert alert--outline alert--success text--center margin--25--bot">
                                Password has been reset successfully.
                            </div>}

                            <form onSubmit={this.handleSubmit} className="form--login">
                                <div className="col-2 gutter--40">
                                    <div className="col full">
                                        <label htmlFor="username" className="">
                                            <span className="sub-title text--grey">Username</span>
                                            <input
                                                id="username"
                                                name="username"
                                                type="text"
                                                className=""
                                                onChange={this.handleChange}
                                                autoFocus
                                            />
                                        </label>
                                    </div>
                                    <div className="col full">
                                        <label htmlFor="password" className="">
                                            <span className="sub-title text--grey">Password</span>
                                            <input
                                                id="password"
                                                name="password"
                                                type="password"
                                                className=""
                                                onChange={this.handleChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <div className="block text--center">
                                    <button className="btn btn--large btn--black" type="submit" disabled={!isSubmitEnabled}>Login</button>
                                </div>
                                <LoadingSpinner isVisible={this.state.isLoading} />
                            </form>

                            <div className="form--login__footer padding--35--top text--12">
                                <Link to="/reset/forgot"><h3 className="text--dark text--14 margin--20--bot">Forgot your password?</h3></Link>
                                <div className="col-2 gutter--40">
                                    <div className="col">
                                        <p>If you need help logging into the portal, please contact IT Support.</p>
                                    </div>
                                    <div className="col">
                                        {IT_SUPPORT_PHONE && <p><strong className="text--caps">Tel</strong> {IT_SUPPORT_PHONE}</p>}
                                        <p><strong className="text--caps">Email</strong> <a href={"mailto:" + IT_SUPPORT_EMAIL}>{IT_SUPPORT_EMAIL}</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </main>

            {this.state.selectStore && <div id="session-expired">
                <div className="vertab">
                    <div className="vertab--inner viewport">
                        <div className="container container--modal padding--100">

                            <div className="bg--white padding--90 padding--100--left padding--100--right text--18 text--center">
                                <img src="/img/icon-home--green.svg" alt="" width="81" height="73" className="icon margin--30--bot" />
                                <SelectInput 
                                    name="storeSelect"
                                    label="Please Select Store"
                                    options={storesOption}
                                    onChange={this.handleChangeStoreSelection}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>}

        </div>
    }
}